module.exports = __webpack_public_path__ + "img/win_spe.f903e6b3.png";